import {configureStore} from "@reduxjs/toolkit";
import constructionNewSlice from "../pages/constructionNew/constructionNewSlice";
import constructionsNewSlice from "../pages/constructionsNew/constructionsNewSlice";
import messagesSlice from "../pages/layout/messagesSlice";
import errorsSlice from "../pages/layout/errorsSlice";
import userInfoSlice from "../services/auth/userInfoSlice";
import constructionCalculationsNoteSlice from "../pages/constructionCalculationsNote/constructionCalculationsNoteSlice";
import constructionCalculationsNewSlice from "../pages/constructionCalculationsNew/constructionCalculationsNewSlice";

export const store = configureStore({
  reducer: {
    constructionsNew: constructionsNewSlice,
    constructionNew: constructionNewSlice,
    constructionCalculationsNew: constructionCalculationsNewSlice,
    constructionCalculationsNote: constructionCalculationsNoteSlice,
    signalRMessages: messagesSlice,
    errors: errorsSlice,
    userInfo: userInfoSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
